module.exports = __webpack_public_path__ + "static/michelin-b0c1394772835f289f831539c09dfddb.svg";